import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractEmailComponent } from '../abstract-email/abstract-email.component';
import { AuthService } from '@aiwyn/auth';
import { AssetUriService } from '@aiwyn/config';
import { Logger } from '@aiwyn/shared';

@Component({
  selector: 'app-password-reset-email',
  templateUrl: './password-reset-email.component.html',
  styleUrls: ['./password-reset-email.component.scss'],
  standalone: false,
})
export class PasswordResetEmailComponent extends AbstractEmailComponent implements OnInit {

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected authService: AuthService,
    public readonly assetUriService: AssetUriService,
    protected logger: Logger
  ) {
    super(route, router, authService, logger);
  }

  ngOnInit(): void {
    super.init();
  }
}
